export default "__VITE_ASSET__7888d386__"